import { render, staticRenderFns } from "./protocolPolicyLuRu.vue?vue&type=template&id=e331e62c&scoped=true&"
import script from "./protocolPolicyLuRu.vue?vue&type=script&lang=js&"
export * from "./protocolPolicyLuRu.vue?vue&type=script&lang=js&"
import style0 from "./protocolPolicyLuRu.vue?vue&type=style&index=0&id=e331e62c&scoped=true&lang=css&"
import style1 from "./protocolPolicyLuRu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e331e62c",
  null
  
)

export default component.exports